/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmploymentSubSkills } from '../../models/employment-sub-skills';

export interface GetEmploymentSubSkillById$Params {
  id: number;
}

export function getEmploymentSubSkillById(http: HttpClient, rootUrl: string, params: GetEmploymentSubSkillById$Params, context?: HttpContext): Observable<StrictHttpResponse<EmploymentSubSkills>> {
  const rb = new RequestBuilder(rootUrl, getEmploymentSubSkillById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmploymentSubSkills>;
    })
  );
}

getEmploymentSubSkillById.PATH = '/employment-sub-skill/{id}';
